<template>
  <div data-qa="placenoticeotherbank-div-jcq1uh">
  <v-list v-if="enablePayeeFormOtherBanks" data-qa="placenoticeotherbank-list-apoo1">
    <v-list-item data-qa="placenoticeotherbank-list-item-mjzvfs">
      <v-list-item-content data-qa="placenoticeotherbank-list-item-content-cqdlve">
        <v-form ref="payeeForm" v-model="isPayeeFormValid" data-qa="placenoticeotherbank-form-n2c8lb">
          <v-text-field
            v-model="payeeForm.accountName"
            :label="$t('domesticPayments.payeeAccountNameLabel')"
            :color="primaryColor"
            :rules="[rules.requiredRule]"
            :maxlength="
              payeeForm.payeeNameMaxLen ? payeeForm.payeeNameMaxLen : false
            "
            filled
            class="transferFunds--custom-textfield"
           data-qa="placenoticeotherbank-text-field-d0jzd"></v-text-field>
          <v-text-field
            v-model="payeeForm.toAccount"
            :label="$t('domesticPayments.payeeAccNoLabel')"
            :color="primaryColor"
            :rules="[rules.requiredRule]"
            filled
            required
            type="password"
            onCopy="return false"
            onpaste="return false"
            class="transferFunds--custom-textfield"
            @keydown="$formatter.validateNumberInput($event)"
           data-qa="placenoticeotherbank-text-field-wq3fnj"></v-text-field>
          <v-text-field
            v-model="payeeForm.reEnteredToAccount"
            :label="$t('domesticPayments.payeeReEnterAccNoLabel')"
            :color="primaryColor"
            :rules="[rules.requiredRule]"
            :error="
              isNumberMatched(payeeForm.toAccount, payeeForm.reEnteredToAccount)
            "
            :error-messages="
              isNumberMatched(payeeForm.toAccount, payeeForm.reEnteredToAccount)
                ? $t('domesticPayments.errorMsgAccNumMatch')
                : ''
            "
            filled
            onCopy="return false"
            onpaste="return false"
            class="transferFunds--custom-textfield"
            @keydown="$formatter.validateNumberInput($event)"
           data-qa="placenoticeotherbank-text-field-mine8d"></v-text-field>
          <v-layout class="pa-0" data-qa="placenoticeotherbank-layout-2umzpx">
            <v-flex xs8 sm8 md8 lg8 xl8 data-qa="placenoticeotherbank-flex-e4k8my">
              <v-text-field
                v-model="payeeForm.sortCode"
                :label="$t('addNewPayee.sortCode')"
                :color="primaryColor"
                :rules="[rules.requiredWithNoErrRule]"
                readonly
                class="transferfunds--nonEditable-textfield"
               data-qa="placenoticeotherbank-text-field-v6e1qg"></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" data-qa="placenoticeotherbank-flex-zxpfh">
              <v-btn
                @click="showSearchForm"
                :color="primaryColor"
                outlined
                class="text-none subtitle-2 font-weight-regular py-2 px-4"
               data-qa="placenoticeotherbank-btn-qsag4w">
                <v-icon class="material-symbols-outlined" size="18px" data-qa="placenoticeotherbank-icon-up1pib">search</v-icon>
                {{ $t("domesticPayments.searchSortCodeBtn") }}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-text-field
            v-model="payeeForm.bankName"
            :label="$t('addNewPayee.bankName')"
            :color="primaryColor"
            :rules="[rules.requiredWithNoErrRule]"
            readonly
            class="transferfunds--nonEditable-textfield"
           data-qa="placenoticeotherbank-text-field-p7bv8m"></v-text-field>
          <!--Whose account? own/others - enable the radio buttons only when nominated account feature is disabled.
                      if nominated account feature is ON then user can add only own accounts-->
          <v-flex
            class="px-3 font-weight-bold"
            xs12
            sm12
            md12
            lg12
            xl12
            v-if="!appSettings.enableNominatedAccountFeatures"
           data-qa="placenoticeotherbank-flex-p5g19c">
            {{ $t("addNewPayee.whoseBankAccount") }}
            <v-radio-group
              v-model="isOwnAccLinked"
              :rules="[fieldRules]"
              row
              class="font-weight-regular"
             data-qa="placenoticeotherbank-radio-group-ns85ci">
              <v-radio
                :label="$t('addNewPayee.ownAccount')"
                value="own"
                :color="secondaryColor"
               data-qa="placenoticeotherbank-radio-v9bdw6"></v-radio>
              <v-radio
                :label="$t('addNewPayee.othersAccount')"
                value="others"
                :color="secondaryColor"
               data-qa="placenoticeotherbank-radio-myn2zi"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-row no-gutters justify="left" class="pa-2" data-qa="placenoticeotherbank-row-yuglut">
            <v-btn
              @click="onAddPayeeOtherBank"
              :color="primaryColor"
              :disabled="!isPayeeFormValid"
              class="white--text text-capitalize py-2 px-4"
             data-qa="placenoticeotherbank-btn-s5ix5">
              {{
                appSettings.enableNominatedAccountFeatures
                  ? $t("addNewPayee.ownAccountTitle")
                  : $t("addNewPayee.addPayeeBtn")
              }}
            </v-btn>
          </v-row>
        </v-form>
      </v-list-item-content>
    </v-list-item>
    </v-list>
    <v-list v-if="enableSortCodeSearchForm" data-qa="placenoticeotherbank-list-h1sajg">
      <v-list-item data-qa="placenoticeotherbank-list-item-qlcszn">
        <v-list-item-content data-qa="placenoticeotherbank-list-item-content-ki9ic">
          <v-row no-gutters class="pb-0" data-qa="placenoticeotherbank-row-c88k3s">
            <v-alert
              icon="mdi-information-outline"
              class="v-alert--info"
             data-qa="placenoticeotherbank-alert-320rvn">
              <font class="caption font-weight-regular">
                {{ $t("domesticPayments.searchSortCodeInfo") }}
              </font>
            </v-alert>
          </v-row>
          <v-form ref="searchSortCodeForm" v-model="isSortCodeSearchFormValid" data-qa="placenoticeotherbank-form-boqfnw">
            <Form
              :config="{
                label: '',
                name: 'SearchSortCode',
                isEnabled: true,
                toolbar: false,
                form: schema.searchSortCodeForm,
              }"
            ></Form>
            <v-row no-gutters justify="left" class="pa-2" data-qa="placenoticeotherbank-row-ip5fp8">
              <v-btn
                @click="onSearchSortCode"
                :color="primaryColor"
                style="margin-left: 12px;"
                class="white--text text-capitalize py-2 px-4"
               data-qa="placenoticeotherbank-btn-lqy1378">
                {{ $t("domesticPayments.searchBtn") }}
              </v-btn>
            </v-row>
          </v-form>
        </v-list-item-content>
      </v-list-item>
      <font
        v-if="sortCodeResults.length"
        class="pl-4 text-h6 font-weight-light"
        >{{ $t("domesticPayments.searchResultsTitle") }}</font
      >
      <div v-if="sortCodeResults.length" data-qa="placenoticeotherbank-div-8ld77">
        <template v-for="(data, index) in sortCodeResults">
          <v-list-item :key="data.nationalid" :data-qa="`placenoticeotherbank-list-item-o1ut-${index}`">
            <v-list-item-content :data-qa="`placenoticeotherbank-list-item-content-to2sui-${index}`">
              <v-flex xs8 sm8 md8 lg8 xl8 :data-qa="`placenoticeotherbank-flex-sn4s9-${index}`">
                <v-list-item-title :data-qa="`placenoticeotherbank-list-item-title-q219j-${index}`">
                  <font class="body-2 font-weight-light">{{
                    convertToCapitalisedSentence(data.instname)
                  }}</font>
                </v-list-item-title>
                <v-list-item-subtitle :data-qa="`placenoticeotherbank-list-item-subtitle-5q3ds-${index}`">
                  <font class="caption">
                    {{ convertToCapitalisedSentence(data.branchinfo) }}
                  </font>
                </v-list-item-subtitle>
                <v-list-item-subtitle :data-qa="`placenoticeotherbank-list-item-subtitle-ha2p3-${index}`">
                  <font class="caption font-weight-bold">{{
                    $t("domesticPayments.sortCodeLabel")
                  }}</font
                  ><font class="caption font-weight-bold">{{
                    maskSortCode(data.nationalid)
                  }}</font>
                </v-list-item-subtitle>
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" :data-qa="`placenoticeotherbank-flex-g3fszb-${index}`">
                <v-btn
                  @click="onSortCodeSelect(data)"
                  :color="primaryColor"
                  outlined
                  class="text-none py-2 px-4"
                  :data-qa="`placenoticeotherbank-btn-n5sjap-${index}`">
                  {{ $t("domesticPayments.selectBtn") }}
                </v-btn>
              </v-flex>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="showDivider(index, sortCodeResults)"
            :key="index"
            :data-qa="`placenoticeotherbank-divider-enos3l-${index}`"></v-divider>
        </template>
      </div>
      <div
        v-if="!searchSortCodeForm.isSearchAvailable && !sortCodeResults.length"
       data-qa="placenoticeotherbank-div-cpy0rl">
        <font class="pl-4 text-h6 font-weight-light">{{
          $t("domesticPayments.searchResultsTitle")
        }}</font>
        <v-list-item data-qa="placenoticeotherbank-list-item-wxnyt">
          <font class="body-2 font-weight-light">{{
            $t("domesticPayments.noSortCode")
          }}</font>
        </v-list-item>
      </div>
    </v-list>
  </div>
</template>
<script>
import getFormConfig from '@/util/formUtility.js'
import UKFPSpayemntTemplate from '@/plugins/UKFPSconfig'
import commonService from '@/service/commonService.js'

export default {
  components: {
    Form: () => import('@/components/DOB-Form/Form.vue')
  },
  data () {
    return {
      searchSortCodeForm: {
        sortCode: '',
        branchName: '',
        bankName: '',
        isSearchAvailable: true,
        minInputLength: 5
      },
      fieldRules: (v) => !!v || 'Required Field',
      isOwnAccLinked: null,
      isSortCodeSearchFormValid: false,
      schema: {},
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      UKFPSpayemntTemplate,
      sortCodeResults: [],
      enableSortCodeSearchForm: false,
      enablePayeeFormOtherBanks: true,
      isPayeeFormValid: false,
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredRusameBankle: (v) => Boolean(v) || 'Required Field',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        isAccBalanceValid: (v) =>
          v && v > 0
            ? new RegExp('^0*(.0*)$').test(v) || v < 0
            : this.$t('errors.common.minAmountError')
      },
      payeeForm: {
        toAccount: '',
        accountName: '',
        reEnteredToAccount: '',
        payeeNameMaxLen:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.intraBank
      }
    }
  },
  created () {
    this.getFormDataSearchCode(`SearchSortCode-${this.$i18n.locale}`)
  },
  methods: {
    showSearchForm () {
      this.enableSortCodeSearchForm = true
      this.enablePayeeFormOtherBanks = false
      this.sortCodeResults = []
      this.searchSortCodeForm.isSearchAvailable = true
    },
    onSortCodeSelect (data) {
      this.enablePayeeFormOtherBanks = true
      this.enableSortCodeSearchForm = false
      // clears all search sortcode fields
      this.schema.searchSortCodeForm.model.sortCode = ''
      this.schema.searchSortCodeForm.model.branchName = ''
      this.schema.searchSortCodeForm.model.bankName = ''
      this.payeeForm.sortCode = data.nationalid
        ? this.maskSortCode(data.nationalid)
        : ''
      this.payeeForm.bankName = data.instname
        ? this.convertToCapitalisedSentence(data.instname)
        : ''
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    async onSearchSortCode () {
      const searchPayload = {
        networkName: 'UKFPS',
        branch: this.schema.searchSortCodeForm.model.branchName,
        bankName: this.schema.searchSortCodeForm.model.bankName,
        directoryIdentifier: this.removeMasking(
          this.schema.searchSortCodeForm.model.sortCode
        ),
        reachability: 'A',
        wildCardSearch: true
      }
      const searchResponse = await commonService.searchUkfpsSortCode(
        searchPayload
      )
      if (searchResponse && !searchResponse.causes) {
        this.sortCodeResults = searchResponse
      }
      if (!searchResponse.length) {
        this.searchSortCodeForm.isSearchAvailable = false
      }
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    maskSortCode (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    onAddPayeeOtherBank () {
      this.enablePayeeFormOtherBanks = true
      this.enableSortCodeSearchForm = false
      this.$emit('addPayeeOtherBank', this.payeeForm,
        this.isOwnAccLinked,
        this.enablePayeeFormOtherBanks)
    },
    async getFormDataSearchCode (formName) {
      try {
        const componentSchema = await commonService.getFormData(formName)
        const data = getFormConfig(componentSchema)
        this.schema.searchSortCodeForm = data
        event.$on('isValid', (arg) => {
          this.isSortCodeSearchFormValid = arg
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
